<div class="bundling-settings-wrapper" data-cy="bundling-settings-wrapper" [ngClass]="{'no-scroll': spinnerObservable | async}">

  @if (spinnerObservable | async) {
    <div class="spinner-container">
      <app-loading-spinner class="center-spinner"></app-loading-spinner>
    </div>
  }

  <div class="bundling-settings-header-wrapper">
    <div class="bundling-settings-title" data-cy="bundling-settings-title">Bundles Settings</div>
    <div class="bundling-settings-close iwp-icon-gen_close_l" data-cy="bundling-settings-close" (click)="closeBundlingSettings()"></div>
  </div>
  <div class="bundling-settings-separator"></div>
  <div class="bundling-settings-tabs-wrapper">
    <div data-cy="bundling-settings-customer-tab">
      <app-bundling-settings-tabs
        (emitTab)="customerTabEmit($event)"
        [tabs]="$safeNavigationMigration(tabsInfo?.tabsCustomerCodes)"
        [changeActiveTab]="changeTabActiveCustomerCode"
        [activeTab]="$safeNavigationMigration(activeTabs?.tabActiveCustomerCode)">
      </app-bundling-settings-tabs>
    </div>
    <p class="bundling-settings-label" data-cy="bundling-settings-label">Bundle type</p>
    <div data-cy="bundling-settings-bundle-type-tab">
      <app-bundling-settings-tabs
        (emitTab)="bundleTypeEmit($event)"
        [tabs]="$safeNavigationMigration(tabsInfo?.tabsBundleTypesCodes)"
        [changeActiveTab]="changeTabsActiveBundleTypeCode"
        [activeTab]="$safeNavigationMigration(activeTabs?.tabsActiveBundleTypeCode)">
      </app-bundling-settings-tabs>
    </div>
  </div>

  <div class="bundling-settings-form">
    <div class="bundling-settings-form-switches">
      <div class="bundling-settings-section">
        <app-switch-button
          [switchButtonConfiguration]="bundlingSettings.partsBundlingSwitch.toggleButtonConfiguration"
          [switchButtonModel]="state.bundlingSwitchButtonModel"
          (switch)="bundlingSwitchToggleHandler($event)"
          data-cy="bundling-switch">
        </app-switch-button>
        <div class="bundling-settings-separator"></div>
      </div>

      <div class="bundling-settings-section">
        <p class="bundling-settings-section-title"
        data-cy="bundling-settings-section-title-periodicity">{{bundlingSettings.periodicityConfiguration.placeholder}}</p>
        <div class="bundling-settings-section-inputs-wrapper">
          <div class="bundling-settings-section-input">
            <p class="bundling-settings-section-input-label light-text"
            data-cy="bundling-settings-section-input-label-periodicity">Period</p>
            <app-input-toggle-dropdown
              [inputToggleDropdownConfiguration]="bundlingSettings.periodicityConfiguration"
              [inputToggleDropdownModel]="state.periodicityModel"
              [dropdownResults]="$safeNavigationMigration(formDropdownsData?.periodicities)"
              (valueChange)="formInputValueHandler($event)"
              data-cy="bundling-settings-section-input-text-line-aggregation">>
            </app-input-toggle-dropdown>
          </div>
          <app-input-toggle-text
            [inputToggleTextConfiguration]="bundlingSettings.periodDaysOffsetConfiguration"
            [inputToggleTextModel]="state.periodDaysOffsetSwitchModel"
            (valueChange)="formInputValueHandler($event)"
            data-cy="bundling-settings-section-input-text-period-days-offset">
          </app-input-toggle-text>
          <app-input-toggle-text
            [inputToggleTextConfiguration]="bundlingSettings.periodMaxBundlesConfiguration"
            [inputToggleTextModel]="state.periodMaxBundlesSwitchModel"
            (valueChange)="formInputValueHandler($event)"
            data-cy="bundling-settings-section-input-text-period-max-bundle">
          </app-input-toggle-text>
        </div>
        <div class="bundling-settings-separator"></div>
      </div>

      <div class="bundling-settings-section">
        <p class="bundling-settings-section-title"
        data-cy="bundling-settings-section-title-bundle-criteria">{{bundlingSettings.bundleCriteriaSection}}</p>
        <app-input-toggle-text
          [inputToggleTextConfiguration]="bundlingSettings.bundleMaxValueConfiguration"
          [inputToggleTextModel]="state.bundleMaxValueSwitchModel"
          [currencyType]="state.currency"
          [customWarningMessage]="state.maxBundleValueCustomWarning"
          (valueChange)="formInputValueHandler($event)"
          data-cy="bundling-settings-section-input-text-bundle-max-value">
        </app-input-toggle-text>
        <div class="bundling-settings-separator"></div>
      </div>

      <div class="bundling-settings-section">
        <p class="bundling-settings-section-title"
        data-cy="bundling-settings-section-title-bundle-aggregation">{{bundlingSettings.bundleAggregationSection}}</p>
        <app-input-toggle-dropdown
          [inputToggleDropdownConfiguration]="bundlingSettings.bundleAggregationConfiguration"
          [inputToggleDropdownModel]="state.bundleAggregationSwitchModel"
          [dropdownResults]="$safeNavigationMigration(formDropdownsData?.bundleCriterionSpecs)"
          (valueChange)="formInputValueHandler($event)"
          data-cy="bundling-settings-section-input-text-bundle-aggregation">
        </app-input-toggle-dropdown>
        <div class="bundling-settings-separator"></div>
      </div>

      <div class="bundling-settings-section">
        <p class="bundling-settings-section-title"
        data-cy="bundling-settings-section-title-line-aggregation">{{bundlingSettings.lineAggregationSection}}</p>
        <div class="bundling-settings-section-inputs-wrapper">
          <app-input-toggle-dropdown
            [inputToggleDropdownConfiguration]="bundlingSettings.lineAggregationConfiguration"
            [inputToggleDropdownModel]="state.lineAggregationSwitchModel"
            [dropdownResults]="$safeNavigationMigration(formDropdownsData?.bundlePositionCriterionSpecs)"
            (valueChange)="formInputValueHandler($event)"
            data-cy="bundling-settings-section-input-text-line-aggregation">>
          </app-input-toggle-dropdown>
          <div class="bundling-settings-section-input">
            <p class="bundling-settings-section-input-label"
            data-cy="bundling-settings-section-input-label-max-bundle-lines">Max bundle lines</p>
            @if (state.bundleMaxPositions.viewMode) {
              <p class="bundling-settings-section-input-text"
              data-cy="bundling-settings-section-input-text-max-bundle-lines">{{$safeNavigationMigration(state?.bundleMaxPositions.value) | undefinedValue}}</p>
            } @else {
              <app-input-toggle-text
                #bundleMaxPositionsEditModeInput
                [inputToggleTextConfiguration]="bundlingSettings.maxBundleLinesConfiguration"
                [inputToggleTextModel]="state.bundleMaxPositions"
                (valueChange)="formInputValueHandler($event)">
              </app-input-toggle-text>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="bundling-settings-form-footer">
      @if (isEditMode) {
        <div class="bundling-settings-separator bold"></div>
        <div class="bundling-settings-form-actions">
          <button class="btn-text-link" data-cy="bundling-settings-form-actions-discard-button" (click)="closeBundlingSettings()">
            Discard
          </button>
          <button class="bundling-settings-form-actions-apply btn-primary"
            data-cy="bundling-settings-form-actions-apply-button"
            [disabled]="!state.isValidToApply"
            (click)="applyBundlingSettings()">Apply
          </button>
        </div>
      }
      <div class="bundling-settings-separator bold"></div>
      <div class="bundling-settings-last-updated">
        <div class="bundling-settings-last-updated-info">
          <p class="bundling-settings-last-updated-label" data-cy="bundling-settings-last-updated-by-label">Last updated by</p>
          <p class="bundling-settings-last-updated-text"
          data-cy="bundling-settings-last-updated-by-text">{{$safeNavigationMigration(state?.lastUpdatedBy) | prettyPrintClosedBy | undefinedValue}}</p>
        </div>
        <div class="bundling-settings-last-updated-info">
          <p class="bundling-settings-last-updated-label" data-cy="bundling-settings-last-updated-on-label">Last updated on</p>
          <p class="bundling-settings-last-updated-text"
          data-cy="bundling-settings-last-updated-on-text">{{$safeNavigationMigration(state?.lastUpdatedOnDate) | undefinedValue}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
